let locales = {
    configStatusLeadsEdit_create: 'Creazzione degli Stati Leads',
    configStatusLeadsEdit_update: 'Aggiornamento degli Stati Leads',
    configStatusLeadsEdit_name: 'Stato',
    configStatusLeadsEdit_description: 'Descrizione dello stato',
};
export default locales;